<template>
  <div class="notice-detail">
    <div class="card">
      <div class="title">人员轨迹异常详情</div>
      <div class="group">
        <div class="cell">
          <img
            class="avatar_img"
            :src="data.signAvatar"
            alt=""
            @click="previewImg(data.signAvatar)"
          />
        </div>
        <div class="cell">
          <label>姓名：</label><span>{{ data.userName }}</span><span v-if="data.personType!=11&&data.personType!=13&&data.personType">（{{ getPersonType(data.personType) }}）</span>
        </div>
        <div class="cell">
          <label>时间：</label
          ><span>{{ data.signTime ? getTime(data.signTime) : "" }}</span>
        </div>
        <div class="cell">
          <label>地点：</label><span>{{ data.location }}</span>
        </div>
        <div
          class="cell"
          v-if="data.location && data.signTime && data.userOrg || data.userName"
        >
          <label>异常原因：</label
          ><span
            >
            {{ data.signTime ? getTime(data.signTime) : "" }}在{{ data.location
            }}发现{{
              data.userOrg
            }}{{ data.userName }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ImagePreview } from "vant";
export default {
  name: "abnormalTrackUrl",
  data() {
    return {
      data: {},
    };
  },
  created() {
    this.getNoticeDetail();
  },
  methods: {
    // 预览图片
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
      });
    },
    getTime(data) {
      return moment(data).format('YYYY-MM-DD HH:mm:ss')
    },
    getPersonType(data) {
      let personTypeList = [
        { name: "学生", value: "11" },
        { name: "家长", value: "12" },
        { name: "教职工", value: "13" },
        { name: "社区居民", value: "14" },
        { name: "访客", value: "2" }
      ];
      let personType = personTypeList.find((item) => {
        return item.value == data;
      });
      return personType ? personType.name : "";
    },
    // 获取报警详情
    getNoticeDetail() {
      this.axios
        .get(`student-consumer/api/abnormalTrackConf/findRecordById`, {
          params: {
            recordId: this.$route.query.recordId,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              this.data = res.data;
            }
          } else {
            this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-detail {
  padding-top: 1rem;
  padding-bottom: 1rem;
  .card {
    .title {
      padding: 0.8rem 1rem;
      font-size: 0.8rem;
      color: #969799;
      border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    }
    margin: 0 1rem 1rem;
    background: #fff;
    box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
    border-radius: 0.75rem;
    .avatar {
      padding: 0;
    }
    .group {
      font-size: 0.85rem;
      .cell {
        padding: 0.8rem 0;
        border-bottom: 1px solid rgba(244, 244, 246, 0.99);
        margin: 0 1rem;
        display: flex;
        align-items: center;
        &:last-child {
          border-bottom: none;
        }
        .avatar_img {
          // width: 100%;
          // height: 12rem;
          // border-radius: 0.5rem;
          // border-radius: none;
          width: 21rem;
      height: 12rem;
      border-radius: 1rem;
      margin: 1rem auto;
      display: block;
      object-fit: cover;
        }
        
        label {
          flex-shrink: 0;
          width: 4.6rem;
          color: #969799;
          display: inline-block;
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
